<script module>
	export const PhoneTypes = {
		Cell: "Cell",
		Home: "Home"
	};
</script>

<script>
	import { onDestroy, onMount } from "svelte";
	import * as Yup from "yup";
	import { imask } from "../../common/actions/imask";
	import { useValidations } from "../../../../../SharedSvelte/Forms.svelte";
	import { formatPhone } from "../../../../../SharedSvelte/Common.svelte";
	import { FormGroup, Input } from "@sveltestrap/sveltestrap";
    
	let {
		phoneType = PhoneTypes.Home,
		phoneNumber,
		required,
		requiredErrorText,
	} = $props();

	const { validateField, validateForm, getErrors, resetErrors, removeError } = useValidations();

	let formData = $state({
		phoneNumber: "",
	});

	if (phoneNumber) {
		formData.phoneNumber = formatPhone(phoneNumber);
	}

	let phoneInputRef;
	let phoneMaskAction;

	let errors = $derived(getErrors());
	let phoneHasErrors = $derived(Object.keys(errors).length ? true : false);

	//const regex = /\(?\b([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})\b/;
	const regexAllowsBlank = /^(?:\(?\b([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})\b)?$/;
	const optionalSchema = Yup.object().shape({
		phoneNumber: Yup.string().nullable()
			.matches(regexAllowsBlank, "Invalid Phone"),
	});

	const requiredSchema = Yup.object().shape({
		phoneNumber: Yup.string()
			.required(requiredErrorText ? requiredErrorText : "Phone Number is required")
			.matches(regexAllowsBlank, "Invalid Phone"),
	});

	let formSchema = $state(required ? requiredSchema : optionalSchema);

	export function clearAllErrors() {
		resetErrors();
	}

	export function getValues() {
		return formData;
	}

	export function setValues(data) {
		formData.phoneNumber = data.phoneNumber;
		resetErrors();
	}

	export function hasErrors() {
		return phoneHasErrors;
	}

	export async function validate() {
		await validateForm(formSchema, formData);
	}

	/*function handlePhoneInput(event) {
		const input = event.target;
		formData.phoneNumber = maskNumericValue(
			input,
			event.inputType,
			"(999) 999-9999",
			formData.phoneNumber,
		);
		validateField(formSchema, "phoneNumber", formData);
	}*/

	$effect(() => {
		if (required) {
			formSchema = requiredSchema;
		} else {
			formSchema = optionalSchema;
			resetErrors();
		}
	});

	onMount(() => {
		phoneMaskAction = imask(phoneInputRef, {
            mask: "(000) 000-0000",
            lazy: true,
        });
	});

	onDestroy(() => {
		phoneMaskAction?.destroy();
	});
</script>

<FormGroup floating spacing="mb-3" label="{phoneType} Phone Number">
	<Input
		placeholder="Phone Number"
		type="text"
		value={formData.phoneNumber}
		bind:inner={phoneInputRef}
		onchange={(e) => validateField(formSchema, "phoneNumber", formData)}
		onaccept={(e) => formData.phoneNumber = e.detail.value}
		invalid={Boolean(errors.phoneNumber)}
		feedback={errors.phoneNumber}
		inputmode="numeric"
		maxlength="14"
	/>
</FormGroup>
